import { PathwayAnswerEventType } from 'analytics/events/pathway-answer';

import { ATTENTION_TODAY, IMMEDIATE_ATTENTION } from 'constants/alertBadge.const';

import { PathwayOptionOutcome, PathwayQuestionTypes } from 'models/PathwayTemplates';

import {
  LightweightPathwayQuestionAction,
  LightweightPathwayQuestionAlertText
} from 'components/LightweightPathway/LightweightPathway.types';

export const pathwayQuestionTypeToAnalyticsTypeMap: Record<
  PathwayQuestionTypes,
  PathwayAnswerEventType
> = {
  [PathwayQuestionTypes.SINGLE]: 'radio',
  [PathwayQuestionTypes.MULTIPLE]: 'multiselection',
  [PathwayQuestionTypes.TEXT]: 'open text',
  [PathwayQuestionTypes.DATE]: 'date',
  [PathwayQuestionTypes.TEXT_ARRAY]: 'text array'
};

export const pathwayAlertToText: Partial<
  Record<PathwayOptionOutcome, LightweightPathwayQuestionAlertText>
> = {
  [PathwayOptionOutcome.CLINIC]: ATTENTION_TODAY,
  [PathwayOptionOutcome.CLINIC_EMERGENT]: IMMEDIATE_ATTENTION,
  [PathwayOptionOutcome.NONE]: ''
};

export const lightweightPathwayQuestionsRemoveActions: LightweightPathwayQuestionAction[] = [
  LightweightPathwayQuestionAction.RemoveLast,
  LightweightPathwayQuestionAction.RemoveLastOption,
  LightweightPathwayQuestionAction.RemoveOption
];

export const NON_SYMPTOM_PATHWAY_ID_PREFIX = 'non-symptom-';

export const isNonSymptomPathway = (pathwayId: string) =>
  pathwayId.includes(NON_SYMPTOM_PATHWAY_ID_PREFIX);

export const NON_SYMPTOM_PATHWAY_NAME = 'Additional Information';
